import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Heading, Paragraph } from '../../components/UI';
import { login } from 'routes/routePaths';
import { Button } from 'lmc-ui-library';

interface Props {}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ExpiredToken: React.FC<Props> = () => {
  return (
    <Wrapper>
      <Heading variant="h1">Sorry, this link to set your password has now expired</Heading>
      <Paragraph>A new link has been sent to you. Please check your inbox and click the new link.</Paragraph>
      <Link to={login}>
        <Button borderVariant="rectangle" mode="ghost" mt={4} mb={5}>
          Return to sign in page
        </Button>
      </Link>
    </Wrapper>
  );
};

export default ExpiredToken;
